import { createContext, useContext, useMemo, useState } from 'react';
import { loginUser, signupUser } from '../lib/api';
import { storeUser, getStoredUser } from '../lib/authSession';
import { getCartSessionId } from '../lib/cartSession';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getStoredUser());

  async function signup(credentials) {
    const response = await signupUser({
      ...credentials,
      sessionId: getCartSessionId(),
    });
    const nextUser = storeUser(response.user);
    setUser(nextUser);
    return response;
  }

  async function login(credentials) {
    const response = await loginUser({
      ...credentials,
      sessionId: getCartSessionId(),
    });
    const nextUser = storeUser(response.user);
    setUser(nextUser);
    return response;
  }

  function logout() {
    storeUser(null);
    setUser(null);
  }

  function updateUser(nextUser) {
    const storedUser = storeUser(nextUser);
    setUser(storedUser);
    return storedUser;
  }

  const value = useMemo(
    () => ({
      user,
      isAuthenticated: Boolean(user),
      login,
      signup,
      logout,
      updateUser,
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuth must be used inside an AuthProvider');
  }

  return context;
}
